<template>
  <v-layout row justify-center>
    <v-dialog v-if="userData" persistent v-model="dialog" max-width="700">
      <v-card>
        <v-card-title>
          <span class="headline mr-4">
            <v-icon class="pl-2">settings</v-icon>
            {{ userData.email }}
          </span>
          <v-btn absolute left depressed flat fab small @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-form ref="edit_user" data-vv-scope="edit_user" lazy-validation>
            <v-layout v-if="loading" row justify-center py-5 >
              <v-progress-circular
                :size="150"
                :width="7"
                color="blue"
                indeterminate
              ></v-progress-circular>
            </v-layout>
            <v-layout v-else row wrap pb-3>
              <v-flex xs5 style="margin: auto;">
                User credits*:
              </v-flex>
              <v-flex xs7>
                <v-text-field
                  class="flex-attribute-input"
                  v-model="credits"
                  persistent-hint
                  v-validate="`required|integer`"
                  data-vv-name="edit_user.credits"
                  :error-messages="errors.collect('edit_user.credits')"
                >
                <template v-slot:append-outer>
                  {{$store.state.metadata.currencySign[$store.state.metadata.currencies[userData.currency]]}}
                </template>
                </v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="closeModal()">Close</v-btn>
          <v-btn color="primary" flat @click="changeUserBalance()" :loading="loading" :disabled="loading">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'EditBalanceModal',
  $_veeValidate: {
    validator: 'new'
  },
  props: ['editBalanceDialog', 'userData', 'loading'],
  data () {
    return {
      dialog: this.editBalanceDialog,
      credits: this.userData.credits,
      rules: {
        required: value => (!!value || value === 0) || 'Required.'
      },
      dictionary: {
        en: {
          custom: {
            'edit_user.credits': {
              required: 'Credits count required',
              integer: 'Only numbers allowed'
            }
          }
        }
      }
    }
  },
  mounted () {
    this.$validator.localize(this.dictionary)
    this.$validator.localize('en')
  },
  watch: {
    editBalanceDialog: {
      handler () {
        this.dialog = this.editBalanceDialog
      }
    },
    dialog: {
      handler () {
        this.$parent.$emit('editBalanceDialog', this.dialog)
      }
    }
  },
  methods: {
    changeUserBalance () {
      this.$validator.validateAll('edit_user').then(res => {
        if (res) {
          this.$parent.$emit('loading', true)
          let params = {
            currency_type: this.userData.currency,
            amount: this.getDiff(),
            user_id: this.userData.id
          }
          this.$store.dispatch('CHANGE_USER_CREDITS', params).then(res => {
            this.$parent.$emit('loading', false)
            this.$parent.$emit('updateUsersList')
            this.$toasted.show('User balance was successfully changed')
            this.closeModal()
          }, err => {
            console.log('CHANGE_USER_CREDITS error', err)
            this.$parent.$emit('loading', false)
            let errorText = this.$services.getApiError(err)
            if (errorText) this.$eventEmitter.$emit('showAlert', 'error', 'Error occurred!', `<p>Error: "${errorText}"</p><p>Our technical support received this error and we will try to fix it ASAP</p>`)
          })
        }
      })
    },
    getDiff () {
      let diff = Math.abs(parseFloat(this.credits) - parseFloat(this.userData.credits))
      if (parseFloat(this.credits) < parseFloat(this.userData.credits)) diff = diff * (-1)
      return diff
    },
    closeModal () {
      this.dialog = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/users/EditBalanceModal.vue